import { finishPasswordReset } from "../../../../services/api";

export default function useFormSubmit(submitStatus,setSubmitStatus){
    if(submitStatus !== 'idle'){
        return ()=>{};//Already something in process, do not try something in the middle, Not likely to get here, as submit button is disabled
    }
    
    return async function(data){
        setSubmitStatus('submits');
        finishPasswordReset(
            data.sesame1,
            ()=>setSubmitStatus('submit-success'),
            r=>{
                console.error('Faild reset password',r);
                setSubmitStatus('failed')
            }
        );
    }
}
